// libraries
import clsx from 'clsx'

// components
import RoundedBox from '/react4xp/components/RoundedBox'

// types
export interface PublicationCardProps {
    className?: string
    href?: {
        href?: string
        external?: boolean
    }
    title?: string
    intro?: string
}

// css
import './index.scss'

export default function PublicationCard({
    className,
    href,
    title,
    intro
}: PublicationCardProps) {
    return (
        <a
            href={href?.href}
            target={href?.external ? '_blank' : undefined}
            rel={href?.external ? 'noopener noreferrer' : undefined}
            className={clsx(
                'publication-card-component',
                className
            )}
        >
            <RoundedBox bgColor='white'>
                <div className='publication-card-component__flex'>
                    
                    {title && (
                        <h2 className='h4'>
                            {title}
                        </h2>
                    )}

                    {intro && (
                        <p className='body'>
                            {intro}
                        </p>
                    )}
                    
                </div>
            </RoundedBox>
        </a>
    )
}